export function setCookie(name, value) {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + (10*60*1000)); // 10 minutes
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expiry.toUTCString()};path=/`;
}

$(document).on('change', '#loan_term', function(event){
    setCookie('clad_term', this.value);
});

$(document).on('change', '#loan_amount', function(event){
    setCookie('clad_la', this.value);
});